import { render, staticRenderFns } from "./permissionsDialog.vue?vue&type=template&id=5dd80f68&scoped=true"
import script from "./permissionsDialog.vue?vue&type=script&lang=ts"
export * from "./permissionsDialog.vue?vue&type=script&lang=ts"
import style0 from "./permissionsDialog.vue?vue&type=style&index=0&id=5dd80f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd80f68",
  null
  
)

export default component.exports